import React, { useState, useEffect } from "react";
import { createTicket, getCustomerProfile } from "../../api";
import "./CreateTicket.css";
import validateForm from "../../utils/validateForm";

const CreateTicket = () => {
  const [formData, setFormData] = useState({
    name: "",
    phoneNumber: "",
    email: "",
    subject: "",
    issueType: "",
    otherIssue: "",
    priorityLevel: "",
    description: "",
    attachment: null,
  });

  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState("");

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await getCustomerProfile();
        const profile = response.data;
        setFormData((prevFormData) => ({
          ...prevFormData,
          name: `${profile.first_name} ${profile.last_name}`,
          phoneNumber: profile.phone_no,
          email: profile.email,
        }));
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };

    fetchProfile();
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  const validationErrors = validateForm(formData);
  setErrors(validationErrors);

  if (Object.keys(validationErrors).length === 0) {
    try {
      const dataToSend = {
        subject: formData.subject,
        issue_type: formData.issueType,
        custom_issue_type:
          formData.issueType === "Other" ? formData.otherIssue : "",
        priority_level: formData.priorityLevel,
        description: formData.description,
        attachment_url: formData.attachment || "",
      };
      const response = await createTicket(dataToSend);
      alert("Ticket Submitted Successfully!");
      setApiError("");
    } catch (error) {
      console.error("Error submitting ticket:", error);
      setApiError(
        error.response?.data?.error ||
          "Failed to submit ticket. Please try again."
      );
    }
  } else {
    alert("Please fix the validation errors.");
  }
};

  const handleBack = () => {
    alert("Going Back...");
  };

  return (
    <div className="container">
      <h2>Support Ticket</h2>
      {apiError && <div className="api-error">{apiError}</div>}
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div>
            <input
              type="text"
              name="name"
              placeholder="Name"
              value={formData.name}
              onChange={handleChange}
              className={`input ${errors.name ? "error-border" : ""}`}
              readOnly
            />
            {errors.name && <span className="error">{errors.name}</span>}
          </div>
          <div>
            <input
              type="text"
              name="subject"
              placeholder="Subject"
              value={formData.subject}
              onChange={handleChange}
              className={`input ${errors.subject ? "error-border" : ""}`}
            />
            {errors.subject && <span className="error">{errors.subject}</span>}
          </div>
        </div>

        <div className="row">
          <div>
            <input
              type="text"
              name="phoneNumber"
              placeholder="Phone Number"
              value={formData.phoneNumber}
              onChange={handleChange}
              className={`input ${errors.phoneNumber ? "error-border" : ""}`}
              readOnly
            />
            {errors.phoneNumber && (
              <span className="error">{errors.phoneNumber}</span>
            )}
          </div>
          <div>
            <select
              name="issueType"
              value={formData.issueType}
              onChange={handleChange}
              className={`select ${errors.issueType ? "error-border" : ""}`}
            >
              <option value="" disabled>
                Issue Type
              </option>
              <option value="Technical Issue">Technical Issue</option>
              <option value="Billing/Account Issue">
                Billing/Account Issue
              </option>
              <option value="Feature Request">Feature Request</option>
              <option value="General Inquiry">General Inquiry</option>
              <option value="Other">Other (Please Specify)</option>
            </select>
            {errors.issueType && (
              <span className="error">{errors.issueType}</span>
            )}
          </div>
        </div>

        {formData.issueType === "Other" && (
          <div className="other-issue-container">
            <input
              type="text"
              name="otherIssue"
              placeholder="Please specify the issue"
              value={formData.otherIssue}
              onChange={handleChange}
              className={`other-issue-input ${
                errors.otherIssue ? "error-border" : ""
              }`}
            />
            {errors.otherIssue && (
              <span className="error">{errors.otherIssue}</span>
            )}
          </div>
        )}

        <div className="row">
          <div>
            <input
              type="email"
              name="email"
              placeholder="Email Id"
              value={formData.email}
              onChange={handleChange}
              className={`input ${errors.email ? "error-border" : ""}`}
              readOnly
            />
            {errors.email && <span className="error">{errors.email}</span>}
          </div>
          <div>
            <select
              name="priorityLevel"
              onChange={handleChange}
              className={`select ${errors.priorityLevel ? "error-border" : ""}`}
              defaultValue=""
            >
              <option value="" disabled>
                Priority Level
              </option>
              <option value="Low">Low</option>
              <option value="Medium">Medium</option>
              <option value="High">High</option>
              <option value="Urgent">Urgent</option>
            </select>
            {errors.priorityLevel && (
              <span className="error">{errors.priorityLevel}</span>
            )}
          </div>
        </div>

        <div className="textarea-container">
          <textarea
            name="description"
            placeholder="Description"
            value={formData.description}
            onChange={handleChange}
            className={`textarea ${errors.description ? "error-border" : ""}`}
          ></textarea>
          {errors.description && (
            <span className="error">{errors.description}</span>
          )}
        </div>

        <div className="row">
          <label className="label">
            <strong>Attach Files</strong> (Optional):
            <input type="file" name="attachment" onChange={handleChange} />
          </label>
        </div>

        <div className="button-group">
          <button type="submit" className="uploadButton">
            Submit
          </button>
          <button type="button" className="backButton" onClick={handleBack}>
            Back
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateTicket;
